import { findIndex } from 'lodash';

export const findIndexById = <T extends Record<string, any>[]>(array: T, id: string | number): number =>
  findIndex(array, item => item.id === id);

export const findIndexByValue = <T extends Record<string, any>[]>(array: T, value: string | number): number =>
  findIndex(array, item => item.value === value);
